import ru from "vuetify/lib/locale/ru";

export default {
  ...ru,
  locale: {
    switcherLabel: "Выберите язык",
  },
  main: {
    paymentAlert: `У Вас есть запланированная сессия на {0}. Для проведения планового платежа за 12 часов до начала сенаса привяжите, пожалуйста, карту.`,
    route: {
      enter: "Вход",
      registration: "РЕГИСТРАЦИЯ",
    },
    logout: "Вы успешно были разлогинены!",
    header: {
      menu: {
        cabinet: "Кабинет",
        consultation: "Консультация",
        main: "Главная",
        settings: "Настройки",
        specialization: "Специализация",
        schedule: "Расписание",
        blog: "Блог",
        psychologists: "Психологи",
        categories: "Категории",
        help: "Помощь",
        exit: "Выход",
        payment: "Оплата",
        ourPsychologists: "Наши терапевты",
        favorites: "Избранные",
        myQuestions: "Мои вопросы",
        guide: "Инструкция и настройки",
        guideShort: "Инструкция",
      },
      menuItem1: 'О проекте',
      menuItem3: 'Для психологов',
      menuItem4: 'Блог',
      menuItem5: 'Для бизнеса',
      // menuItem6: 'О нас',
      EnterButton: 'Вход'
    },
    redactorDashboard: {
      author: "Автор статьи (психолог)",
      authorUrl: "Или ссылка для кнопки «Об авторе»",
      authorHint: "Кнопка «Об авторе» в статье ведёт на страницу психолога, у «Команды Платформы» — на каталог психологов",
      authorTeam: "Команда Платформы",
      likes: "Лайки (количество на сайте)",
      redactors: {
        title:
          "В данном разделе вы можете создать/удалить профиль редактора для блога",
        createRedactor: "Создать профиль редактора",
        delete: "Удалить",
        cancel: "Отмена",
        accept: "Применить",
        name: "Имя*",
      },
      blog: {
        title:
          "В данном разделе вы можете создать новую статью или редактировать ранее созданную",
        allBlogs: "Все ранее созданные статьи:",
        create: "Создать",
        all: "Все",
        published: "Опубликованные",
        waiting: "Запланированные",
        draft: "Черновики",
        langDesk: "Каждую статью возможно создать на 2 языках",
        cancel: "Отмена",
        accept: "Применить",
        createBlog: "Создать статью",
        editBlog: "Редактировать статью",
        publishTime: "Время публикации",
        publishDate: "Дата публикации",
        publishNow: "Опубликовать сейчас",
        previewPhoto: "Фото для заголовка",
        imageSize: "Размер картинки",
        deleteBlog: "Удалить статью",
        deleteConfirm: "Удалить статью навсегда? Восстановить её будет невозможно.",
        deleteYes: "Да, удалить",
        viewOnSite: "Посмотреть на сайте",
        saveAsDraft: "Сохранить как черновик",
        editorHint: "Список «Текст» над полем: Заголовок и Подзаголовок разделов. Кнопка с кавычками делает выделенный цветной блок. Цвет текста и фона рядом с кнопками B, I, U, первый ряд палитры это фирменные цвета Платформы. Нажмите на картинку в тексте, чтобы изменить её размер. Пустая строка между абзацами не нужна.",
      },
      categories: {
        title: "В данном разделе вы можете создать/удалить категорию для блога",
        delete: "Удалить",
        create: "Создать",
        createCategory: "Создать новую категорию",
        createdCategories: "Созданные категории:",
      },
    },
    adminDashboard: {
      psychologists: {
        placement: {
          title: "Показ в каталоге",
          shownUntil: "Показывается до",
          shownFree: "Показывается (оплата пока не обязательна)",
          hidden: "Не показывается",
          days: "дней",
          show: "Показывать анкету",
          hide: "Скрыть анкету",
          confirmHide: "Скрыть из каталога анкету",
        },
        unmatchedPayments: {
          title: "Оплаты без анкеты",
          hint: "Оплата размещения пришла, но почта и телефон из неё не совпадают ни с одной анкетой. Выберите психолога и нажмите «Зачислить»: анкета появится в каталоге, психолог получит письмо об оплате, а следующие ежемесячные оплаты с этой почтой или телефоном зачислятся ему автоматически.",
          psychologist: "Психолог",
          assign: "Зачислить",
        },
        unpaidPlacement: {
          title: "Психологам без оплаты: показ в каталоге",
          apply: "Применить",
          confirmTitle: "Показ без оплаты",
          confirmText: "Психологов без оплаты: {count}. Их анкеты будут показываться в каталоге {days} дней, в кабинете будет видно, сколько дней осталось. После этого понадобится оплата, как у всех.",
          nobody: "Сейчас нет активных психологов без оплаты.",
          confirm: "Применить",
          cancel: "Отмена",
        },
        admin_status: {
          0: "Все",
          1: "Без статуса",
          2: "Не соответствует критериям",
          3: "Собеседование",
          4: "На доработку",
          5: "На активацию",
          6: "В очередь",
          7: "Резерв",
          8: "Чёрный список",
        },
        profile_tag: {
          0: "Все",
          1: "Обновлена ссылка на видеовизитку",
          2: "Обработана ссылка на видеовизитку",
        },
        month: "Месяц",
        mainTitle:
          "В данном разделе вы можете активировать/деактивировать психологов на платформе",
        changePhotoRequire: "Фото профиля требует подтверждения",
        changePhotoWarning: "Необходимо загрузить фото",
        changePhotoDone: "Фото профиля подтверждён",
        rating: "Рейтинг",
        current: "Текущий",
        last: "Прошлый",
        swalText: {
          deleted: "Пользователь успешно удален",
          activated: "Анкета активирована. Выполняется обновление списков...",
          deactivated:
            "Анкета деактивирована. Выполняется обновление списков...",
          updated: "Данные обновлены",
          invalidPhone: "Указан не валидный номер телефона",
        },
        tabs: {
          inactivePsychologists: "Новые анкеты",
          activePsychologists: "Активные психологи",
          deactivatedPsychologists: "Деактивированные",
          archivedPsychologists: "Архив",
        },
        buttons: {
          confirmUpdates: "Подтвердите изменения",
          downloadPhoto: "Скачать фото",
          uploadPhoto: "Загрузить фото",
          downloadAll: "Скачать все",
          download: "Скачать",
          activate: "Активировать",
          deactivate: "Деактивировать",
          apply: "Применить",
          viewProfile: "Посмотреть анкету",
          back: "Назад",
          forward: "Далее",
          closeForm: "Закрыть анкету",
          btnEdit: "Редактировать",
          btnCancel: "Отменить",
          btnSave: "Сохранить",
          confirmDelete: "Вы действительно хотите удалить",
          confirmActivate: "Активировать анкету",
          confirmDeactivate: "Деактивировать анкету",
          confirmY: "Подтвердить",
          confirmN: "Отменить",
        },
        switcherLabel: {
          yes: "Да",
          no: "Нет",
        },
        stepsTitle: {
          generalInformation: "Общая информация",
          mainTreatmentMethod: "Основной метод",
          workExperience: "Опыт работы",
          aboutInfo: "О себе",
        },
        inputLabel: {
          main: {
            uploadPhoto: "Загрузить фото",
            stepOne: {
              firstName: "Имя",
              secondName: "Фамилия",
              patronymic: "Отчество",
              dateOfBirth: "Дата рождения",
              citizenship: "Гражданство",
              phone: "Телефон",
              university: "Название ВУЗа",
              faculty: "Название факультета",
              speciality: "Специальность",
              scienseDegree: "Академическая или ученая степень",
              yearOfEnding: "Год окончания",
            },
            stepThree: {
              workExperience: "Опыт работы",
              additionalProgram:
                "Полное название и количество пройденных часов",
            },
            stepFour: {
              from: "От",
              to: "До",
            },
          },
          questionnaire: {
            title: "Анкета",
            answer: "Ответ...",
            stepOne: {
              education: "Образование",
              certificatesTitle:
                "Фотографии развернутых дипломов и сертификатов, подтверждающих обучение:",
            },
            stepTwo: {
              mainTreatmentMethod: "Основной метод",
              additionalEducation: "Дополнительное образование",
              problems: "Проблемы с которыми работает",
            },
            stepThree: {
              workExperience:
                "Сколько лет вы консультируете? За деньги, не в рамках учебной программы.",
              additionalProgram:
                "Какие дополнительные программы прошли или проходите на данный момент?",
              selfTherapy: "Проходите ли вы личную психотерапию?",
              regularSupervision: "Проходите ли вы регулярно супервизии?",
            },
            stepFour: {
              aboutInfo:
                "Расскажите о себе в свободной форме. Что считаете нам нужно узнать о вас, чтобы понять, какой вы специалист?",
              warning: "Эта информация будет отображаться на сайте",
              shortDescription: "Коротко о себе (показывается в карточке каталога)",
              notWorkingWith: "С чем вы не работаете?",
              infoChannel:
                'Как вы узнали о наборе терапевтов в сервис "Платформа"?',
              clientsQuantity:
                'Как количество клиентов вы готовы взять на "Платформа"?',
              profileLinks: "Укажите ссылки на профили в социальных сетях ",
            },
          },
        },
      },
    },
    psychologistDashboard: {
      guide: {
        title: "Инструкция и настройки",
        instruction: "Инструкция для психологов",
        instructionText: "Как заполнить анкету, настроить расписание, видеосвязь и другие возможности кабинета.",
        instructionSoon: "Инструкция появится здесь в ближайшее время.",
        open: "Открыть инструкцию",
        updates: "Обновления платформы",
        noUpdates: "Обновлений пока нет.",
        new: "Новое",
        more: "Подробнее",
      },
      googleCalendar: {
        howTitle: "Как подключить Google Календарь",
        title: "Расписание из Google Календаря",
        statusOn: "Подключено",
        statusError: "Ошибка обновления",
        intro: "Отмечайте время для записи клиентов в приложении на телефоне - слоты на сайте появятся автоматически.",
        step1: "<b>Создайте календарь:</b> откройте <a href=\"https://calendar.google.com\" target=\"_blank\" rel=\"noopener\">calendar.google.com</a> ➔ слева возле <em>«Другие календари»</em> нажмите <code>+</code> ➔ <em>«Создать календарь»</em> ➔ назовите его, например, <b>«Платформа»</b>.",
        step2: "<b>Скопируйте ссылку:</b> в настройках нового календаря найдите раздел <em>«Интеграция календаря»</em> и скопируйте <b>«Секретный адрес в формате iCal»</b>.",
        step3: "<b>Подключите:</b> вставьте ссылку в поле ниже и нажмите <b>«Подключить»</b>.",
        step4: "<b>Как это работает:</b> Создавайте события в этом календаре через телефон (например, 10:00–13:00 откроет слоты на 10, 11 и 12 часов). Расписание на сайте (с учетом часовых поясов) обновляется каждые 15 минут.",
        urlLabel: "Секретный адрес в формате iCal",
        connect: "Подключить",
        note: "Адрес видит только сервер Платформы. Мы только читаем календарь и ничего в нём не меняем; забронированные клиентами часы не меняются. События на весь день не учитываются.",
        connectedText: "Свободные часы берутся из вашего Google Календаря. Чтобы изменить расписание, измените события в календаре.",
        syncedAt: "Обновлено",
        freeHours: "Свободных часов на месяц",
        syncNow: "Обновить сейчас",
        disconnect: "Отключить календарь",
        failed: "Не удалось подключить календарь",
      },
      publicPage: {
        offline: "Офлайн-консультации",
        offlineHint: "Если принимаете клиентов лично — добавьте город (до 5). Он появится в анкете, а клиенты найдут вас в фильтре «Офлайн» каталога. Адрес — по желанию.",
        country: "Страна",
        city: "Город",
        cityNotOnline: "Здесь указывайте город, где принимаете лично. Онлайн-консультации уже показываются в анкете, слово «Онлайн» писать не нужно.",
        address: "Адрес или район (необязательно)",
        addOffline: "Добавить город",
        tab: "Публичная страница",
        title: "Ваша страница на Платформе",
        hint: "Отдельная страница с вашим именем в ссылке. Её можно добавить в Instagram, Telegram или на визитку.",
        copy: "Копировать",
        copied: "Ссылка скопирована",
        specialty: "Кто вы (будет в ссылке и на странице)",
        specialtyHint: "Например: психолог, психотерапевт. Выбирайте 1-2 специализации, чтобы ссылка оставалась короткой и удобной.",
        specialtyOptions: "Психолог|Психотерапевт|Супервизор|Клинический психолог|Сексолог|Детский психолог|Семейный психолог|Консультант|Коуч",
        tooLong: "Не более 100 символов",
        languages: "Языки консультаций",
        languagesHint: "Через запятую, например: украинский, английский. Показывается в анкете.",
        workCountry: "Страна, где вы работаете",
        workCountryHint: "Раздел каталога, в котором показывается ваша анкета.",
        introSession: "Провожу сессию-знакомство",
        introSessionHint: "Клиенты найдут вас в фильтре каталога «Сессия-знакомство».",
        languagesTooLong: "Не более 255 символов",
        shortDescription: "Коротко обо мне",
        shortDescriptionHint: "Одно-два предложения о том, какой вы специалист. Показывается в карточке психолога в каталоге под методом работы.",
        shortDescriptionTooLong: "Не более 160 символов",
        contacts: "Контакты",
        contactsHint: "Посетители увидят их после нажатия кнопки «Контакты». Каждое нажатие учитывается в статистике.",
        prices: "Стоимость консультаций",
        pricesHint: "Добавьте все виды консультаций, которые вы проводите.",
        pricesUahOnly: "Ціни консультацій тепер лише в гривнях. Вкажіть, будь ласка, у гривнях ціни, що були в доларах чи євро (виділені червоним), і збережіть.",
        priceWasInCurrency: "Раніше ціна була {price} — вкажіть, будь ласка, суму в гривнях",
        priceTitle: "Вид консультации",
        priceDuration: "Минут",
        priceAmount: "Цена",
        addPrice: "Добавить вид консультации",
        contact: {
          phone: "Телефон",
          email: "Email",
          telegram: "Telegram",
          viber: "Viber",
          whatsapp: "WhatsApp",
          instagram: "Instagram",
          facebook: "Facebook",
          tiktok: "TikTok",
          youtube: "YouTube",
          linkedin: "LinkedIn",
          website: "Сайт",
        },
      },
      stats: {
        title: "Статистика анкеты",
        views: "Просмотры анкеты",
        contactsClicks: "Нажатия «Контакты»",
        contactsViews: "Просмотры контактов",
        favorites: "Добавили в избранное",
        favoritesSub: "за всё время",
        statusTitle: "Статус анкеты",
        statusActive: "Активна",
        statusInactive: "Не активна",
        lockMessage: "Ваша анкета не активна! Чтобы начать получать запросы от клиентов и пользоваться инструментами платформы, пожалуйста, активируйте подписку.",
        activateSubscription: "Активировать подписку",
        lockClose: "Закрыть",
        hiddenFromCatalog: "Анкета не показывается в каталоге",
        nextPayment: "Следующая оплата",
        manageSubscription: "Управлять подпиской",
        deactivated: "Ваша анкета сейчас не показывается на Платформе. Если вы хотите возобновить показ, напишите, пожалуйста, нашей службе поддержки.",
        archivedPay: "Ваша анкета сейчас не показывается в каталоге. Оплатите размещение, и она снова появится на Платформе автоматически.",
        paySubscription: "оплатить подписку",
        total: "За всё время",
        thisMonth: "В этом месяце",
        lastDays: "За 30 дней",
        placement: "Размещение анкеты",
        paidUntil: "Оплачено до",
        notPaid: "Не оплачено",
        notEnforced: "Анкета показывается в каталоге",
        expired: "Срок оплаты истёк, анкета не показывается в каталоге",
        daysLeft: "Осталось дней",
      },
      videoRoom: {
        title: "Ваша видеокомната",
        hint: "Постоянная ссылка для клиента. Комната без ограничения времени: вы открываете её, когда готовы, клиент заходит по ссылке.",
        link: "Ссылка для клиента",
        copy: "Копировать",
        copied: "Ссылка скопирована",
        open: "Открыть комнату",
        close: "Закрыть комнату",
        regenerate: "Новая ссылка",
        generateNew: "Сгенерировать новую ссылку",
        regenerateConfirm: "Старая ссылка перестанет работать. Продолжить?",
        opened: "Комната открыта",
        closed: "Комната закрыта",
        waiting: "Ожидаем клиента…",
        guestJoined: "Клиент в комнате",
        connecting: "Соединение…",
        kick: "Завершить с клиентом",
        cameraError: "Нет доступа к камере или микрофону. Разрешите доступ в браузере.",
        connectionLost: "Соединение потеряно, пробуем восстановить…",
      },
      settings: {
        sex: "Ваш пол",
        imageInput: "Загрузить новое фото",
        notificationLabel: {
          1: "За 1 час",
          2: "За 2 час",
          5: "За 5 часов",
          12: "За 12 часов",
          24: "За 24 часа",
        },
        mainSettings: "Главные настройки",
        aboutInfo: "О себе",
        education: "Образование",
        workExperience: "Опыт работы",
        certificates: "Сертификаты",

        aboutYou: "О вас",
        yourAvatar: "Ваша аватарка:",
        avatarDesc:
          "Ваша аватарка находится на рассмотрении Администрации, это не занимает много времени.",
        avatarAlt: "Аватар психолога",
        name: "Ваше имя:",
        nameLabel: "Имя",
        lastName: "Ваша фамилия:",
        lastNameLabel: "Фамилия",
        patronymic: "Ваше отчество:",
        patronymicLabel: "Отчество",

        timezone: "Ваш часовой пояс:",
        howOld: "Сколько вам лет ?",
        birthday: "Дата рождения",

        contacts: "Контакты и настройки уведомлений",
        phone: "Телефон",
        email: "Эл. Почта",
        emailLabel: "Почта",

        about_info:
          "Расскажите о себе в свободной форме. Что считаете нам нужно знать о вас, чтобы понять, какой Вы специалист ? Эта информация будет отображаться на сайте.",
        aboutInfoLabel: "О себе:",
        aboutResizeHint: "Щоб розширити текстове поле - просто потягніть мишкою за правий нижній куток рамки.",
        shortDescription: "Короткий опис",
        shortDescriptionLead: "Це ваше коротке позиціонування на картці спеціаліста. Влучний опис підкаже клієнту, чи саме ви той фахівець, якого він шукає, та заохотить перейти у ваш профіль.",
        shortDescriptionNote: "Сформулюйте ваш головний меседж: із якими запитами ви працюєте та в чому цінність сесій із вами.",
        shortDescriptionTooLong: "Не більше 300 символів",
        aboutTitle: "Расскажите о себе и своем подходе к работе",
        aboutLead: "Поделитесь тем, что, по вашему мнению, важно знать будущему клиенту:",
        aboutPoint1: "В каких направлениях и с какими запросами вы работаете?",
        aboutPoint2: "Каких принципов придерживаетесь в терапии?",
        aboutPoint3: "Что для вас важно во взаимодействии с человеком?",
        aboutNote: "Эта информация будет отображаться в вашей карточке в каталоге и поможет клиентам почувствовать, подходите ли вы им как специалист.",

        youtube: "Ссылка на видеовизитку в YouTube",
        youtubeLabel: "Посилання (YouTube)",
        video: "Ссылка на видеовизитку",
        videoLabel: "Посилання",
        videoOptional: "Это необязательное поле при регистрации.",
        videoHint: "Если вы используете Google Drive, убедитесь, что открыт доступ для всех по ссылке",

        consultingExperience:
          "Сколько лет Вы консультируете? За деньги, не в рамках учебной программы.",
        consultingExperienceLabel: "Опыт работы",
        additionalProgram:
          "Какие дополнительные программы прошли или проходите на данный момент?",
        coursesLabel: "Полное название и количество пройденных часов",
        selfTherapy: "Проходите ли Вы личную терапию?",
        regularSupervision: "Проходите ли Вы регулярно супервизии?",
        yes: "Да",
        no: "Нет",
        save: "Сохранить",
        update: "Обновить",
        yourCertificates: "Ваши сертификаты",
        uploadDoc: "Загрузить документ",
        cancel: "Отменить",
        accept: "Подтвердить",
        download: "Просмотреть",
        delete: "Удалить",

        rules: "Поле обязательно для заполнения.",
        nameRules: 'Поле "Имя" обязательно при заполнении',
        lastnameRules: 'Поле "Фамилия" обязательно при заполнении',
        emailRules1: 'Поле "E-mail" обязательно при заполнении',
        emailRules2: "E-mail должен быть валидным",
        youtubeRules1: "Некорректная ссылка YouTube",
        consultingExperienceRules1: "Пол обязательно при заполнении",
        consultingExperienceRules2: "Некорректный ввод",
        consultingExperienceRules3: "Пожалуйста введите правдивые данные",
        coursesRules1: "Поле обязательно при заполнении",
        coursesRules2: "Это поле должно содержать не менее 10 символов",
        countrySelectorLabel: "Код страны",
        countrySelectorError: "Ошибка странны",
        phoneNumberLabel: "Номер телефона",
        example: "Пример :",
        year: "год",
        years: "лет",
        years2: "года",
        error: "Вы еще не можете изменять это поле.",
      },
      mainPage: {
        currentClient: "Текущий клиент:",
        clientsProblem: "Проблемы клиента:",
        rating: "Ваш рейтинг:",
        nextSession: "Ближайшая сессия:",
        skipNextSession: "Отменить сессию",
        todayClients: "Ваши клиенты на сегодняшний день",
        webRTC: {
          connection: "Подключаемся...",
          nextSessionWillBee: "Следующая сессия будет",
          textInformationInVideoPlayer:
            "В момент начала Вашего сеанса, кнопка для подключения к звонку появится ниже.",
          connectToCallBtn: "Присоединится к звонку",
          rateTheSession: "Оцените сессию",
          rateBtn: "Оценить",
          settings: "Настройки",
          scanningNextSession: "Сканируем..",
          psychologistSpinnerMessage:
            "Клиент еще не подключился, пожалуйста ожидайте...",
          clientSpinnerMessage:
            "Психолог еще не подключился, пожалуйста ожидайте...",
          remoteStatusVueSwall: "присоединяется",
          warningCallWillFinishVueSwall:
            "ВНИМАНИЕ! Звонок закончится через 5 минут.",
        },
      },
      welcomeMessage: {
        hello: "Здравствуйте,",
        title: "Рады приветствовать в вашем рабочем кабинете на Платформе",
        subtitle: "Ваша анкета сейчас находится на рассмотрении.",
        description:
          "Это значит, что вы не можете вести деятельность, пока ваш профиль не будет подтвержден администратором!",
        informing:
          "После рассмотрения анкеты (может рассматриваться до 2-х недель) мы свяжемся с вами и договоримся о собеседовании.",
        informing2: "Следите за электронной почтой.",
      },
      schedule: {
        swallCancelSessionByPsychologist: "Отменяем сеанс..",
        swallCancelSessionByPsychologistTitle:
          "Вы уверены, что хотите отменить сеанс ?",
        swallYes: "Да",
        swallNo: "Нет",
        client: "Клиент: ",
        instruction: "Инструкция",
        calendarTitle: "Заполнение календаря не обязательно, но это существенно повышает доверие клиентов!",
        calendarText: "Актуальный график показывает, что вы активный специалист, который ответственно относится к своей практике. Клиентам намного проще и комфортнее обращаться к психологу, чье свободное время они видят сразу.",
        calendarCta: "Регулярно заполняйте календарь, чтобы увеличить количество обращений и конверсию записей!",
        example1: "Пример 1",
        exampleDesk11: "- Время, когда вы ",
        exampleDesk12: "Не Готовы ",
        exampleDesk13: "работать (клиенту не отображается это время)",
        example2: "Пример 2",
        exampleDesk21: "- Время, когда вы ",
        exampleDesk22: "Готовы ",
        exampleDesk23: "работать (клиенту отображаетс это время для записи)",
        example3: "Пример 3",
        exampleDesk31:
          "- Время, забронированное клиеном для работі. У вас есть возможность отминить косультацию, так как до неё еще больше чем 24 часа",
        // exampleDesk32: "Вы не отображаетесь ",
        // exampleDesk33:
        //   "другим клиентам. А также у Вас есть возможность отменить сеанс, так-как до сеанса еще более 24 часов.",
        example4: "Пример 4",
        exampleDesk41:
          "- Время, забронированное клиентом для работы. Но вы не имеете возможности отменить консультацию, так как до неё осталось меньше чем 24 часа",
        // exampleDesk42: "Вы также не отображаетесь ",
        // exampleDesk43:
        //   "другим клиентам . А также у Вас нет возможности отменить сеанс, так-как до сеанса менее 24 часов.",
      },
    },
    patientDashboard: {
      myQuestions: {
        title: "Мои вопросы",
        ask: "Задать вопрос",
        empty: "Здесь будут ваши вопросы с форума и ответы психологов на них.",
        toForum: "Перейти на форум",
        new: "Новые ответы:",
        pending: "На проверке",
        noAnswers: "Ответов пока нет",
        answerForms: "ответ|ответа|ответов",
        openOnSite: "Открыть на сайте",
        newMark: "новое",
        you: "Вы",
        clarify: "Уточнить вопрос",
        clarifyHint: "Уточнение появится на форуме под ответом психолога",
        send: "Отправить",
        tooShort: "Напишите уточнение",
        failed: "Не удалось отправить. Попробуйте позже",
      },
      favorites: {
        addFavorite: "Добавить в избранное",
        removeFavorite: "Убрать из избранного",
        title: "Избранные психологи",
        empty: "Здесь будут психологи, которых вы добавили в избранные. Нажмите сердечко на карточке или в анкете психолога на сайте.",
        toCatalog: "Перейти в каталог",
        remove: "Убрать из избранных",
        open: "Смотреть анкету",
      },
      blog: {
        header:
          "Мудрый совет, интересная история, список полезных лайфхаков или научная статья. Кто знает, какое знание придется вам по душе сегодня?",
        subtitle1: "Хорошо, что у нас есть выбор.",
        subtitle2:
          "Лучшие статьи помогут найти ответы на непростые и очень важные вопросы, отдохнуть душой и познакомиться с мнением экспертов проекта.",
        andMore: "...и еще много интересного",
      },
      main: {
        userAgreementLink: "пользовательском соглашении.",
        swallCancelSession: "Отменяем предыдущий сеанс..",
        swallBookedSession: "Бронируем новый сеанс..",
        paymentBtn: "Привязать карту",
        paymentMethodWarning:
          "Сеанс будет автоматически отменён. Чтобы этого не случилось, привяжите карту для оплаты",
        hello: "Здравствуйте ",
        yourTherapist: "Ваш терапевт: ",
        nonTherapist: "На данный момент у Вас нет терапевта.",
        chooseTherapist: "Выбрать терапевта",
        switchTherapist: "Поменять терапевта",
        warning:
          "Для отображения полного функционала - требуется привязать карту.",
        connectCard: "Привязать карту",
        nextSession: "Следующая сессия",
        shiftSession: "Перенести сессию",
        shiftSessionOnSelectedTime: "Перенести сессию на",
        bookedSession: "Забронировать сессию",
        bookedSessionOnSelectedTime: "Забронировать сессию на",
        cancelSession: "Отменить сессию",
        warningSession1:
          "Переносить можно не позднее чем за 12 часов до начала сессии. Полные условия читайте в ",
        warningSession2: "пользовательском соглашениии ",
        and: "и ",
        warningSession3: "договоре оказания услуг ",
        withPsychologist: "с психологом ",
        cancel: "Отмена",
        shiftTo: "Перенести на ",
      },
      settings: {
        timezone: "",
        title: "Личные данные",
        name: "Ваше имя:",
        age: "Сколько вам лет?",
        contacts: "Контакты и настройки уведомлений",
        smsNotification: "СМС-напоминания за 1 час до начала сессии",
        hint: "Ваш e-mail используется для напоминания о предстоящих сессиях",
        blogLabel: "Хочу получать новости сервиса",
        // blogLabel: "Новости сервиса и важное из блога",
        notificationLabel: "Напоминания по почте",
        timeLabel: "Выберите время",
        beforeSession: "до начала сеанса.",
        save: "Сохранить",
        refresh: "Обновить",
        infoText1: "Подпишитесь на",
        infoText2: "чтобы получить быструю поддержку или найти ответы на частые вопросы",
        infoText3: "Уведомления будут приходить на почту и в Telegram-бот",
        infoTextList1: "- сразу после оплаты сеанса",
        infoTextList2: "- сразу после переноса или отмены сеанса",
        infoTextList3: "- за 1 час до начала сеанса",
        infoTextList4: "- когда психотерапевт создал для вас предварительное бронирование сеанса",
        infoTextList5: "- когда психотерапевт отменил предварительное бронирование сеанса",
      },
      ourPsychologists: {
        oops: "Упс..мы ничего не смогли найти по твоему запросу: c",
        workExperience: "Опыт работы ",
        showFully: "Показать полностью..",
        chooseDateTime: "Выберите дату и время:",
        chooseTime: "Выбрать время",
        book: " Забронировать ",
        on: "на ",

        lifeEvent: "События жизни",
        condition: "Состояние",
        relationship: "Отношение",
        career: "Работа, карьера, учеба",

        stress: "Стресс",
        panic_attacks: "Панические атаки",
        low_self_esteem: "Низкая самооценка",
        sleep_problems: "Проблемы со сном",
        emotional_addiction: "Эмоциональная зависимость",
        hypochondria: "Ипохондрия, переживание о здоровье",
        alcohol_drugs_addiction: "Зависимость, от алкоголя, наркотиков",
        anxiety: "Страх, тревожность",
        breakdown: "Упадок сил",
        mood_swings: "Перепады настроения",
        irritability: "Раздражительность",
        feelings_of_loneliness: "Ощущение одиночества",
        social_network_addiction: "Зависимость от социальных сетей",
        eating_disorders: "Расстройство пищевого поведения",

        with_partner: "С партнёром",
        with_children: "С детьми",
        sexual: "Сексуальные",
        with_parents: "С родителями",
        common: "В целом, с окружающими",

        stress_at_work: "Стресс, выгорание",
        procrastination: "Прокрастинация",
        no_goal: "Отсутствие цели",
        lack_of_motivation: "Недостаток мотивации",
        cannot_find_myself: '"Не знаю, чем хочу заниматься"',
        job_loss_change: "Смена, потеря работы",

        relocate_emigration: "Переезд, эмиграция",
        financial_changes: "Финансовые изменения",
        betrayal: "Измена",
        illness: "Болезнь, своя или близких",
        pregnancy: "Беременность, рождение ребёнка",
        divorce: "Разрыв отношений, развод",
        violence: "Насилие",
        loss_of_a_loved_one: "Утрата близкого человека",
      },
      payment: {
        month: "Месяц",
        year: "Год",
        cardInfo: "Данные платежной карты",
        cardDesk:
          "Данная карта используется для оплаты консультаций с Вашим терапевтом.",
        untieCard: "Отвязать карту",
        untieCardDesk: "Ваша карта не привязана",
        bookInfo:
          "Для бронирования консультации необходимо привязать платёжную карту",
        connectCard: "Привязать карту ",
        cancel: "Отмена",

        cardNumber: "Номер карты",
        cardOwner: "Владелец карты",
        expireDate: "Срок действия",
      },
    },
    patientReg: {
      title: "Регистрация клиента",
      agreeText: "Регистрируясь, вы соглашаетесь с",
      agreeTerms: "пользовательским соглашением",
      agreeAnd: "и",
      agreePolicy: "политикой конфиденциальности",
      generalQuestions: "Общие вопросы",
      personalQuestions: "Личные вопросы",
      therapists: "Выбор терапевта",
      terms: "Условия оплаты",
      further: "Далее",
      back: "Назад",
      apply: "Подать заявку",
      select: "Выбрать",
      stepOne: {
        yourName: "Как вас зовут?",
        nameDesk: "Ваше имя будет доступно вашему психологу",
        nameLabel: "Имя",
        yourAge: "Сколько вам лет?",
        ageDesk: "Для получения услуг вы должны быть старше 16 лет",
        ageLabel: "Возраст",
        therapyExperience: "Был ли у вас опыт терапии?",
        whichConsultationType: "Какая консультация нужна?",
        yes: "Да",
        no: "Нет",
        consultationType: "Выберите тип косультации",
        single: "Для себя",
        family: "Семейная",
        timeZone: "Часовой пояс",
        patientNameRules: 'Поле "Имя" обязательно при заполнении',
        patientAgeRules1: 'Поле "Возраст" обязательно при заполнении',
        patientAgeRules2: "Для получения услуг вы должны быть старше 16 лет.",
        patientEmailRules1: 'Поле "E-mail" обязательно при заполнении',
        patientEmailRules2: "E-mail должен быть валидным",
      },
      stepTwo: {
        selectThemes:
          "Выберите темы, с которыми вы хотите поработать с психологом",
        warning: "Необходимо выбрать, хотя бы одну тему",
        whatDiscuss: "Что вы хотели бы обсудить в первую очередь?",
        lifeEvent: "События жизни",
        condition: "Состояние",
        relationship: "Отношение",
        career: "Работа, карьера, учеба",

        relocate_emigration: "Переезд, эмиграция",
        financial_changes: "Финансовые изменения",
        betrayal: "Измена",
        illness: "Болезнь, своя или близких",
        pregnancy: "Беременность, рождение ребёнка",
        divorce: "Разрыв отношений, развод",
        violence: "Насилие",
        loss_of_a_loved_one: "Утрата близкого человека",

        stress: "Стресс",
        panic_attacks: "Панические атаки",
        low_self_esteem: "Низкая самооценка",
        sleep_problems: "Проблемы со сном",
        emotional_addiction: "Эмоциональная зависимость",
        hypochondria: "Ипохондрия, переживание о здоровье",
        alcohol_drugs_addiction: "Зависимость, от алкоголя, наркотиков",

        anxiety: "Страх, тревожность",
        breakdown: "Упадок сил",
        mood_swings: "Перепады настроения",
        irritability: "Раздражительность",
        feelings_of_loneliness: "Ощущение одиночества",
        social_network_addiction: "Зависимость от социальных сетей",
        eating_disorders: "Расстройство пищевого поведения",

        with_partner: "С партнёром",
        with_children: "С детьми",
        sexual: "Сексуальные",

        with_parents: "С родителями",
        common: "В целом, с окружающими",

        stress_at_work: "Стресс, выгорание",
        procrastination: "Прокрастинация",
        no_goal: "Отсутствие цели",
        lack_of_motivation: "Недостаток мотивации",
        cannot_find_myself: '"Не знаю, чем хочу заниматься"',
        job_loss_change: "Смена, потеря работы",
      },
      stepThree: {
        workExperience: "Опыт работы",
        worksWith: "Работает с",
        outOf: "из",
        topics: "тем Вашей анкеты",
        soon: "Ближайшее время:",
        selectSessionTime: "Выбрать время сессии",
        aboutSpecialist: "О специалисте",
        canContactMe: "Вы можете обратиться ко мне:",
        education: "Образование",
        therapyMethod: "Метод терапии",
        workTopics: "Специалист работает с темами из вашей анкеты:",
        dateAndTime: "Выберите дату и время сессии",
        canShift: "Можно перенести за 12 часов",
        price: "Фиксированная цена {0} ",
      },
      stepFour: {
        price: "Стоимость сессии составит ",
        termsPart1: "После того, как вы привяжете карту, мы снимем с неё",
        termsPart2:
          "и сразу же вернём обратно. Это стандартная процедура проверки.",
        termsPart31: "Деньги списываются с карты ",
        termsPart32: "за 12 часов ",
        termsPart33:
          "до сессии – и после того, как это произошло, вы уже не сможете её перенести или отменить.",
        termsPart41: "Вы в любой момент ",
        termsPart42: "можете отвязать ",
        termsPart43: "свою карту. Это можно сделать в личном кабинете.",
        termsPart5:
          "Все сессии проводятся по видеосвязи из личного кабинета и вам потребуется стабильное подключение к интернету.",
        important: "Важно! ",
        termsPart6: `Нажимая кнопку «Привязать карту» вы подтверждаете, что ознакомлены и согласны с договором оказания услуг и даёте согласие на обработку персональных данных психологу.`,
        psychologist: "Терапевт:",
        sessionDate: "Дата и время сессии:",
      },
    },
    psychologistReg: {
      networkError: "Что-то пошло не так. Возможно, вы пытаетесь загрузить слишком большие файлы.",
      emailCodeSpam: "Если вы не видите письмо, проверьте папку Спам",
      emailCode:
        "Вам был отправлен код на указанную почту, введите его в поле выше, пожалуйста.",
      generalInformation: "Общая информация",
      mainTreatmentMethod: "Основной метод",
      workExperience: "Опыт работы",
      aboutInfo: "Расскажите о себе",
      further: "Далее",
      back: "Назад",
      apply: "Подать заявку",
      stepOne: {
        sex: 'Пол',
        male: 'Мужской',
        female: 'Женский',
        desk: "Некоторые поля необходимо заполнить на 2 языках",
        phoneRules: 'Поле "телефон" обязательно при заполнении',
        phoneRules2: 'Поле "телефон" должно содержать только цыфры',
        birthRule:
          'Поле "дата рождения" должно быть в формате "год-месяц-день"',
        firstName: "Имя",
        secondName: "Фамилия",
        patronymic: "Отчество",
        dateOfBirth: "Дата рождения",
        citizenship: "Гражданство",
        phone: "Телефон",
        university: "Название ВУЗа",
        faculty: "Название факультета",
        speciality: "Специальность",
        scienseDegree: "Академическая или ученая степень",
        yearOfEnding: "Год окончания",
        year: "Год",
        education: "Образование",
        add_education: "Добавить образование",
        descRules: 'Поле "Описание" обязательно при заполнении',
        descRulesUA: 'Поле "Опис" обязательно при заполнении',
        photoDesc:
          "Пожалуйста, прикрепите фотографии развернутых дипломов и сертификатов, подтверждающих обучение",
        diploma_and_certificates: "Дипломы и сертификаты",
        nameRules: 'Поле "Имя" обязательно при заполнении',
        lastnameRules: 'Поле "Фамилия" обязательно при заполнении',
        emailRules1: "E-mail должен быть валидным",
        emailRules2: 'Поле "E-mail" обязательно при заполнении',

        educationRules: 'Поле "Образование" обязательно при заполнении',
        universityRules: 'Поле "Название ВУЗа" обязательно при заполнении',
        facultyRules: 'Поле "Название факультета" обязательно при заполнении',
        specialityRules: 'Поле "Специальность" обязательно при заполнении',
        sexRules: 'Поле "Пол" обязательно при заполнении',
        scienceDegreeRules:
          'Поле "Академическая или ученая степень" обязательно при заполнении',

        yearOfEndingRules1: 'Поле "Год окончания" обязательно при заполнении',
        yearOfEndingRules2: 'Поле "Год окончания" должно содержать 4 символа',
        yearRules1: 'Поле "Год" обязательно при заполнении',
        yearRules2: 'Поле "Год" должно содержать 4 символа',
        citizenshipRules: 'Поле "Гражданство" обязательно при заполнении',

        bachelors: "Бакалавр",
        master: "Магистр",
        doctoral: "Доктор наук",
        candidate_of_sciences: "Кандидат наук",
        diploma_and_certificates_desk: "Основные и дополнительные",
      },
      stepTwo: {
        another: "Другое",
        mainTreatmentMethod: "Выберите Ваш основной метод:",
        additionalEducation:
          "Выберите, если у вас есть дополнительное образование, касающееся следующих тем:",
        additionalEducationDesk:
          "Напишите, пожалуйста, в какой области у вас есть дополнительное образование?",
        problems: "Выберите, проблемы с которыми вы можете помочь:",

        art_therapy: "Арт-терапия",
        positive_psychotherapy: "Позитивная психотерапия",
        client_centered_psychotherapy: "Клиент-центрированная психотерапия",
        cognitive_behavioral_therapy: "Когнитивно-поведенческая терапия",
        body_therapy: "Телесная терапия",
        psychoanalysis: "Психоанализ",
        jungian_analysis: "Юнгианский анализ",
        transactional_analysis: "Транзактный анализ",
        family_therapy: "Семейная терапия",
        gestalt_therapy: "Гештальт-терапия",
        psychodrama: "Психодрама",
        analytical_psychology: "Аналитическая психология",
        symboldrama: "Символдрама",
        existential_analysis: "Экзистенциальный анализ",
        nlp: "НЛП",
        emdr: "EMDR",
        schema_therapy: "Схема-терапия",
        emotional_imagery_therapy: "Эмоционально-образная терапия",
        integrative_approach: "Интегративный подход",
        act_therapy: "АСТ-терапия",
        hypnotherapy: "Гипнотерапия",
        coaching: "Коучинг",
        logotherapy: "Логотерапия",
        children: "Детский психолог",
        teenagers: "Психолог для подростков",

        addictions: "Зависимости",
        sexology: "Сексология",
        extreme_situations: "Экстремальные ситуации, ПТСР",
        couples_therapy: "Парная терапия",
        lgbt: "ЛГБТК+",

        lifeEvent: "События жизни",
        condition: "Состояние",
        relationship: "Отношение",
        career: "Работа, карьера, учеба",

        relocate_emigration: "Переезд, эмиграция",
        financial_changes: "Финансовые изменения",
        betrayal: "Измена",
        illness: "Болезнь, своя или близких",
        pregnancy: "Беременность, рождение ребёнка",
        divorce: "Разрыв отношений, развод",
        violence: "Насилие",
        loss_of_a_loved_one: "Утрата близкого человека",

        stress: "Стресс",
        panic_attacks: "Панические атаки",
        low_self_esteem: "Низкая самооценка",
        sleep_problems: "Проблемы со сном",
        emotional_addiction: "Эмоциональная зависимость",
        hypochondria: "Ипохондрия, переживание о здоровье",
        alcohol_drugs_addiction: "Зависимость, от алкоголя, наркотиков",
        anxiety: "Страх, тревожность",
        breakdown: "Упадок сил",
        mood_swings: "Перепады настроения",
        irritability: "Раздражительность",
        feelings_of_loneliness: "Ощущение одиночества",
        social_network_addiction: "Зависимость от социальных сетей",
        eating_disorders: "Расстройство пищевого поведения",

        with_partner: "С партнёром",
        with_children: "С детьми",
        sexual: "Сексуальные",
        with_parents: "С родителями",
        common: "В целом, с окружающими",

        stress_at_work: "Стресс, выгорание",
        procrastination: "Прокрастинация",
        no_goal: "Отсутствие цели",
        lack_of_motivation: "Недостаток мотивации",
        cannot_find_myself: '"Не знаю, чем хочу заниматься"',
        job_loss_change: "Смена, потеря работы",
      },
      stepThree: {
        year: "год",
        years: "лет",
        years2: "года",
        years3: "года",
        workExperienceLabel: "Опыт работы",
        workExperience:
          "Сколько лет вы консультируете? За деньги, не в рамках учебной программы.",
        additionalProgram:
          "Какие дополнительные программы прошли или проходите на данный момент?",
        additionalProgramLabel: "Полное название и количество пройденных часов",
        selfTherapy: "Проходите ли вы личную психотерапию?",
        regularSupervision: "Проходите ли вы регулярно супервизии?",
        rules: "Поле обязательно при заполнении",
        consultingExperienceRules1: "Некорректный ввод",
        consultingExperienceRules2: "Пожалуйста введите правдивые данные",
        coursesRules: "Это поле должно содержать не менее 10 символов",
        yes: "Да",
        no: "Нет",
      },
      stepFour: {
        swallWriteToDB: "Создаем учетную запись",
        aboutInfo:
          "Расскажите о себе в свободной форме. Что считаете нам нужно узнать о вас, чтобы понять, какой вы специалист?",
        warning: "Эта информация будет отображаться на сайте",
        notWorkingWith: "С чем вы не работаете?",
        infoChannel: 'Как вы узнали о наборе терапевтов в сервис "Платформа"?',
        clientsQuantity:
          'Какое количество клиентов вы готовы взять на "Платформа"?',
        from: "От",
        to: "До",
        mediaLinksTitle: "Укажите ссылки на профили в социальных сетях",
        photoTitle: "Прикрепите вашу фотографию",
        photoLabel: "Ваше фото",
        requirements: "Требования к фото:",
        requirements1: "Цветное",
        requirements2: "Лицо по центру и хорошо освещено",
        requirements3: "Размер не менее 1МБ",
        requirements4: "В формате (название).jpg",
        rules: "Поле обязательно при заполнении",
        socialMediaLinksMin50: "Это поле должно содержать не менее 10 символов",
        socialMediaLinks2k: "Это поле должно содержать не более 2000 символов",
        textAreaValidationRulesMin50:
          "Это поле должно содержать не менее 50 символов",
        textAreaValidationRules:
          "Это поле должно содержать не более 2000 символов",
        entrepreneurRules: "Это поле должно содержать не менее 10 символов",
      },
    },
    footer: {
      tagline: "Каталог проверенных психологов",
      diiaCatalog: "Платформа в каталоге",
      agreement: "Пользовательское соглашение",
      privacy: "Политика конфиденциальности",
      rights: "Все права защищены.",
      supportBotText: "Поддержка",
      rateUs: "Оцените нас",
      questions: "Остались вопросы? ",
      contacts: "Мы всегда на связи",
      legal: {
        mainText:
          ' <b>Важный момент.</b> "Платформа" — это не скорая психологическая\n' +
          "            помощь. Если у вас серьезные, угрожающие вашей жизни проблемы,\n" +
          "            которые требуют немедленного решения, вам лучше обратиться в\n" +
          "            какую-либо из этих организаций.",
        userAgreementPart1: "Регистрация на сайте означает согласие с",
        userAgreementLink: "пользовательским соглашением.",
        userAgreementPart2: "Политика в отношении ",
        userAgreementLink2: "обработки и защиты персональных данных",
        terms:
          "При использовании любых материалов этого сайта, ссылка на источник обязательна.",
        protected: "Все права защищены!",
      },
      footerMenu: {
        aboutProject: "О проекте",
        forPsychologists: "Для психологов",
        forBusinessShort: "Для бизнеса",
        services: "Каталог услуг",
        askQuestion: "Задать вопрос",
        expertArticles: "Экспертные статьи",
        tests: "Психологические тесты",
        events: "События психологов",
        FAQ: "Вопросы-Ответы",
        Contacts: "КОНТАКТЫ",
        workOffers: "РАБОТА В ПЛАТФОРМА",
        blog: "БЛОГ",
        ourPsychologists: "НАШИ ПСИХОЛОГИ",
        forBusiness: "ПЛАТФОРМА ДЛЯ БИЗНЕСА",
      },
    },
  },
  view: {
    room: {
      title: "Видеоконсультация",
      with: "Психолог",
      yourName: "Ваше имя",
      join: "Войти в комнату",
      waitingHost: "Психолог ещё не открыл комнату. Страница обновится сама, как только он подключится.",
      busy: "Сейчас у психолога другой клиент. Попробуйте чуть позже.",
      notFound: "Комната не найдена. Проверьте ссылку.",
      connecting: "Соединение с психологом…",
      connected: "Соединено",
      leave: "Выйти",
      left: "Вы вышли из комнаты",
      rejoin: "Войти снова",
      kicked: "Психолог завершил встречу",
      cameraError: "Нет доступа к камере или микрофону. Разрешите доступ в браузере и обновите страницу.",
      mic: "Микрофон",
      camera: "Камера",
    },
    common: {
      methodOfWork: 'Метод работы',
      aboutSpecialist: 'О специалисте',
      education: 'Образование',
      worksWith: 'Работает с темами',
      typeOfConsultation: 'Вид консультации',
      schedule: 'Расписание',
      more: 'Больше',
      less: 'Меньше',
      сhoose: 'Выбрать',
      videoIntroduction: 'Видеовизитка',
      individualSession: 'Индивидуальная сессия 50 мин',
      couplesSession: 'Парная сессия 90 мин',
      forMyself: 'Для себя',
      couples: 'Парная',
      additionTextConsultationType1Time: '50 мин',
      additionTextConsultationType2Time: '1,5 часа',
    },
    psychologists: {
      oops: 'Упс..мы ничего не смогли найти по твоему запросу.',
      preview: {
        mainTitle: 'Наши специалисты',
        subtitle: 'Квалифицированные специалисты с проверенным образованием и опытом, прошедшие строгий отбор Платформы',
      },
      filters: {
        filters: 'Фильтры',
        show_psychologists: 'Показать психолога(ов)',
        clear: 'Очистить',
        show: 'Показать',
        close: 'Закрыть',
        symptoms: 'Симптомы',
        specialization: 'Метод работы',
        sex: 'Пол',
      },
      sex_options: {
        male: 'Мужской',
        female: 'Женский',
      },
      sort_options: {
        default: 'Рекомендованные',
        exp_desc: 'Сначала более опытные',
        price_desc: 'Сначала дороже',
        price_asc: 'Сначала дешевле',
      },
      specialization: {
        title: "В данном разделе вы можете отредактировать анкетные данные",
        subtitle: "Выберите, проблемы с которыми вы можете помочь:",
        main_treatment_method: "Выберите Ваш основной метод:",
        additionalEducation:
          " Выберите, если у вас есть дополнительное образование, касающееся следующих тем:",
        other: "Другое",
        anotherSelectTextArea:
          "Напишите, пожалуйста, в какой области у вас есть дополнительное образование?",

        art_therapy: "Арт-терапия",
        positive_psychotherapy: "Позитивная психотерапия",
        client_centered_psychotherapy: "Клиент-центрированная психотерапия",
        cognitive_behavioral_therapy: "Когнитивно-поведенческая терапия",
        body_therapy: "Телесная терапия",
        psychoanalysis: "Психоанализ",
        jungian_analysis: "Юнгианский анализ",
        transactional_analysis: "Транзактный анализ",
        family_therapy: "Семейная терапия",
        gestalt_therapy: "Гештальт-терапия",
        psychodrama: "Психодрама",
        analytical_psychology: "Аналитическая психология",
        symboldrama: "Символдрама",
        existential_analysis: "Экзистенциальный анализ",
        nlp: "НЛП",
        emdr: "EMDR",
        schema_therapy: "Схема-терапия",
        emotional_imagery_therapy: "Эмоционально-образная терапия",
        integrative_approach: "Интегративный подход",
        act_therapy: "АСТ-терапия",
        hypnotherapy: "Гипнотерапия",
        coaching: "Коучинг",
        logotherapy: "Логотерапия",
        children: "Детский психолог",
        teenagers: "Психолог для подростков",

        addictions: "Зависимости",
        sexology: "Сексология",
        extreme_situations: "Экстремальные ситуации, ПТСР",

        // psychologist filters
        life_event_problems: "События жизни",
        mental_health_condition_problems: "Состояние",
        relationship_problems: "Отношения",
        career_problems: "Работа, карьера, учеба",
        /******************************************/

        relocate_emigration: "Переезд, эмиграция",
        financial_changes: "Финансовые изменения",
        betrayal: "Измена",
        illness: "Болезнь, своя или близких",
        pregnancy: "Беременность, рождение ребёнка",
        divorce: "Разрыв отношений, развод",
        violence: "Насилие",
        loss_of_a_loved_one: "Утрата близкого человека",

        stress: "Стресс",
        panic_attacks: "Панические атаки",
        low_self_esteem: "Низкая самооценка",
        sleep_problems: "Проблемы со сном",
        emotional_addiction: "Эмоциональная зависимость",
        hypochondria: "Ипохондрия, переживание о здоровье",
        alcohol_drugs_addiction: "Зависимость, от алкоголя, наркотиков",

        anxiety: "Страх, тревожность",
        breakdown: "Упадок сил",
        mood_swings: "Перепады настроения",
        irritability: "Раздражительность",
        feelings_of_loneliness: "Ощущение одиночества",
        social_network_addiction: "Зависимость от социальных сетей",
        eating_disorders: "Расстройство пищевого поведения",

        with_partner: "С партнёром",
        with_children: "С детьми",
        sexual: "Сексуальные",
        gender_identity_exploration: "Поиск гендерной идентичности",

        with_parents: "С родителями",
        common: "В целом, с окружающими",

        stress_at_work: "Стресс, выгорание",
        procrastination: "Прокрастинация",
        no_goal: "Отсутствие цели",

        lack_of_motivation: "Недостаток мотивации",
        cannot_find_myself: '"Не знаю, чем хочу заниматься"',
        job_loss_change: "Смена, потеря работы",

        save_changes: "Сохранить изменения",
      }
    },
    psychDescrModal: {
      session: 'Сессия',
      showAll: 'Показать полностью..',
      seeAll: 'Смотреть полностью',
      aboutMyself: 'О себе',
      methodOfWork: 'Метод работы',
      book: 'Забронировать',
      close: 'Закрыть',
      experiense: 'Опыт работы ',
      experience_with_years: 'Опыт работы {count} {year}',
      yearForms: 'год|года|лет'
    },
    blog: {
      search: "Поиск по статьям",
      categories: "Категории",
      title: "Блог",
      subtitle: "Данный раздел находится в разработке.",
      localisationWarning: "Статья написана на 1-м языке",
      posted: "Опубликован",
      close: "Закрыть",
      readMore: "Читать статью полностью",
      nextPost: "Следующая статья",
      previousPost: " Предыдущая статья",
    },
    signIn: {
      registrationProviderExpired: "Вход через Google или Apple устарел. Войдите ещё раз и вернитесь к анкете: заполненные поля сохранятся, фото и сертификаты нужно будет добавить снова.",
      registrationProviderOnly: "Для регистрации сначала войдите через Google или Apple — так вы сможете входить в кабинет без SMS.",
      smsDisabled: "Вход по SMS отключён. Войдите через Google или Apple.",
      loginGoogleTitle: "Продолжить через Google",
      linkingLoginGoogleTitle: "Добавить вход через Google",
      loginAppleTitle: "Продолжить через Apple",
      linkingLoginAppleTitle: "Добавить вход через Apple",
      phoneText1: "введите свой украинский номер телефона,",
      phoneText2: "мы отправим вам одноразовый код",
      or: "или",
      title:
        "Пожалуйста, введите свой номер телефона с кодом страны, мы пришлём вам одноразовый пароль",
      termsPart1: "Авторизуясь, вы принимаете условия, ",
      termsPart2: "пользовательского соглашения ",
      termsPart3: "даёте согласие на ",
      termsPart4: "обработку персональных данных ",
      termsPart5:
        "и даёте согласие на получение СМС-паролей, а также иных информационных и сервисных сообщений на указанный номер телефона.",
      code: "Получить код",
      loading: "Загрузка...",
      countrySelectorLabel: "Код страны",
      countrySelectorError: "Ошибка странны",
      phoneNumberLabel: "Номер телефона",
      example: "Пример :",
      oldLoginLink1: "Настроить вход",
      oldLoginLink2: "для номера телефона",
      loginLink: "Перейти ко входу",
      linkingLoginText: "Выберите удобный для вас способ входа для дальнейшей авторизации.",
      user_not_exists: "Эта операция недоступна для данного пользователя.",
    },
    verify: {
      title: "ВВЕДИТЕ КОД",
      desk: "Код действителен в течение 10 минут. Код отправлен!",
      resendCode: "Отправить код повторно",
      resendCodeDesk:
        "Срок действия временного кода истек. Отправить код повторно?",
      accept: "Подтвердить",
      loading: "Загрузка...",
      viberCode1: "Не пришел код ?",
      viberCode2: "Отправить код на Viber",
    },
    registration: {
      welcomeMessagePsyh:
        "Если вы психолог и хотите стать частью нашей команды",
      welcomeMessagePatient:
        "Если вы хотите найти именно своего психолога и решить свой запрос",
      desk: "Для начала работы с Платформой необходимо пройти регистрацию",
      patient: "Регистрация для клиента",
      psychologist: "Регистрация для психолога",
      title:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
    },
    restore: {
      text: "Ваш аккаунт было удалено. Выберите, что сделать дальше:",
      restoreHint: "Восстановить удалённый аккаунт и продолжить работу.",
      restore: "Восстановить аккаунт",
      deleteHint: "Удалить аккаунт окончательно и зарегистрироваться заново.",
      delete: "Создать новый аккаунт",
      user_not_exists: "Данные устарели. Попробуйте ещё раз.",
      error: "Произошла ошибка. Пожалуйста, повторите попытку позже.",
      delete_success: "Аккаунт окончательно удалён.",
      delete_dialog: "Вы действительно хотите удалить аккаунт навсегда?",
      user_exists: "Этот аккаунт недоступен. Попробуйте другой.",
    },
    emailRegistration: {
      title: "Введите Ваш E-mail",
      desk: 'Всё общение с сервисом "Платформа" происходит через письма на почту. Мы пришлём Вам письмо с итогом по Вашей заявке.',
      accept: "Подтвердить",
      loading: "Загрузка...",
      emailRules1: 'Поле "E-mail" обязательно при заполнении',
      emailRules2: "E-mail должен быть валидным",
    },
    auth: {
      logout: "Ви успішно були розлогінені!",
      psychologist: {
        Schedule: {
          title: "Расписание",
          subtitle:
            "Заполните свой рабочий график, когда вы готовы рабоать с клиентами Платформы.",
          description:
            "Расписание отображается в формате - текущий день + 30 дней.",
          btnSave: "Сохранить",
          btnEdit: "Редактировать",
        },
      },
    },
  },
  developmentSection: {
    title: "Данный раздел находится в разработке.",
  },
  pageNotFound: {
    Oops: "Уупс..",
    description: "Страница которую Вы ищите, не существует. ",
  },
};
